import React from "react";
import FeedDataContainer from "@commr/admin/components/feeds/feedDataContainer";
import Feed from "@commr/admin/models/feed/feed";

const AddFeedsPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <FeedDataContainer feed={new Feed()} />
);

export default AddFeedsPage;
